import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    notice: {
      content: '',
      closeable: true,
      showNotice: false
    },
  },
  getters: {
  },
  mutations: {
    setNotice(state, notice) {
      state.notice = { ...state.notice, ...notice }
    }
  },
  actions: {
    async fetchNotice({ commit }) {
      try {
        const response = await fetch('/api/notice/list')
        const data = await response.json()
        if (data.ok && data.data) {
          let notice = data.data[0] // 获取最新的通知

          const noticeId = localStorage.getItem('currentNoticeId') 
          if (noticeId && noticeId == (notice.id + notice.updateTime)) {
            notice.showNotice = false
          } else {
            notice.showNotice = true
          }

          commit('setNotice', notice)
        }
      } catch (error) {
        console.error('获取通知失败:', error)
      }
    }
  },
  modules: {
  }
})
